var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 56,
    viewBox: "0 0 210 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 207.935,
    height: 53.783,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.137,2.727h7.982v5.48H31.694q-6.567-.037-6.567,5.948v2.722q0,5.824,6.567,5.824h5.424v5.424H29.137q-9.869,0-9.871-12.7t9.871-12.7",
    transform: "translate(40.384 5.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.661,18.341v9.886h-5.75V2.721h5.75v10.14h7.075V2.721h5.753V28.228H38.736V18.341Z",
    transform: "translate(54.315 5.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.066,24.43,38.614,28.2H32.79L41.769,4.24A2.74,2.74,0,0,1,42.75,3.1,2.631,2.631,0,0,1,44.2,2.68,2.788,2.788,0,0,1,45.67,3.1a2.517,2.517,0,0,1,1,1.142l9.109,23.983H49.933L48.463,24.43Zm6.257-5.5-2.105-5.387L42.15,18.935Z",
    transform: "translate(68.733 5.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.75,
    height: 25.506,
    transform: "translate(127.23 8.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.623,2.937v22.8a2.762,2.762,0,0,1-.545,1.669,2.846,2.846,0,0,1-4.589.019L49.526,14.873V28.391h-5.7V5.457a2.857,2.857,0,0,1,1.96-2.7,2.767,2.767,0,0,1,1.762,0,2.806,2.806,0,0,1,1.43,1.019l8.945,12.533V2.937Z",
    transform: "translate(91.872 5.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.75,
    height: 25.506,
    transform: "translate(158.217 8.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.631,2.937v22.8a2.762,2.762,0,0,1-.545,1.669,2.846,2.846,0,0,1-4.589.019L59.534,14.873V28.391h-5.7V5.457a2.857,2.857,0,0,1,1.96-2.7,2.767,2.767,0,0,1,1.762,0,2.806,2.806,0,0,1,1.43,1.019l8.945,12.533V2.937Z",
    transform: "translate(112.851 5.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.754,22.7V15.827H79.5v12.3H70.98q-9.869,0-9.871-12.7t9.871-12.7H79.5v5.48H73.537q-6.567,0-6.567,5.948V16.88q0,5.824,6.313,5.824Z",
    transform: "translate(128.094 5.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.893,19.657q1.486,0,1.486-2.356,0-2.336-1.486-2.338H21.6v3.164h-.012v3.31H19.753V13.229l3.421-.006q3.135,0,3.133,4.13,0,4.078-3.133,4.084h-.92v-1.78Z",
    transform: "translate(41.405 27.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.858,
    height: 8.236,
    transform: "translate(68.592 40.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.122,19.676v-2.22H28.98v3.972H26.224q-3.186,0-3.186-4.1t3.186-4.1H28.98v1.768H27.054q-2.122,0-2.124,1.923V17.8q0,1.881,2.04,1.879Z",
    transform: "translate(48.291 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.858,
    height: 8.236,
    transform: "translate(78.147 40.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.028,21.435V15h-1.9V13.227H31.75V15H29.938v6.434Z",
    transform: "translate(54.76 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.009,20.234l-.471,1.22H27.656l2.9-7.74a.889.889,0,0,1,.316-.368.856.856,0,0,1,.468-.133.884.884,0,0,1,.474.133.787.787,0,0,1,.322.368l2.944,7.747H33.192l-.471-1.226Zm2.022-1.774-.681-1.74-.666,1.74Z",
    transform: "translate(57.971 27.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.085,13.227v6.434h3.421v1.768H31.738q-1.551,0-1.551-1.669V13.227Z",
    transform: "translate(63.277 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.049,13.227h2.579v1.768H36.876c-1.415-.006-2.121.632-2.121,1.923V17.8q0,1.881,2.121,1.879h1.752v1.752H36.049q-3.186,0-3.186-4.1t3.186-4.1",
    transform: "translate(68.886 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.853,14.928v6.505H35.014l-.006-8.208h4.3a2.017,2.017,0,0,1,1.489.533,1.96,1.96,0,0,1,.57,1.517,2.189,2.189,0,0,1-.663,1.564l-.721.851a.548.548,0,0,0-.053.573l1.771,3.17H39.448l-1.365-2.672a1.387,1.387,0,0,1,0-1.582l1.35-1.616a.644.644,0,0,0,.167-.418c0-.146-.093-.217-.276-.217Z",
    transform: "translate(73.382 27.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.583,21.429H38.815q-1.551,0-1.551-1.669V14.71c0-.991.517-1.483,1.551-1.483h3.768v1.762H39.162v1.474H42v1.743H39.162v1.455h3.421Z",
    transform: "translate(78.111 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.615,20.234l-.468,1.22H39.265l2.9-7.74a.889.889,0,0,1,.316-.368.859.859,0,0,1,.471-.133.9.9,0,0,1,.474.133.8.8,0,0,1,.322.368L46.69,21.46H44.8l-.474-1.226Zm2.022-1.774-.681-1.74-.666,1.74Z",
    transform: "translate(82.305 27.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.283,21.435V15h-1.9V13.227h5.626V15H45.194v6.434Z",
    transform: "translate(86.737 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.858,
    height: 8.236,
    transform: "translate(134.621 40.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6,13.208q2.949,0,2.948,4.158T48.6,21.527H47.311q-2.944,0-2.948-4.161t2.948-4.158Zm-.545,1.768h-.2q-1.6.009-1.6,1.923v.994q0,1.881,1.653,1.882h.1q1.653,0,1.653-1.882V16.9q0-1.913-1.6-1.923",
    transform: "translate(92.992 27.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.359,13.294v7.363a.918.918,0,0,1-1.2.876A.879.879,0,0,1,51.7,21.2l-2.892-4.053v4.366H46.969V14.109a.916.916,0,0,1,.632-.873.887.887,0,0,1,.567,0,.9.9,0,0,1,.464.328l2.889,4.05V13.294Z",
    transform: "translate(98.454 27.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.895,21.435V15h-1.9V13.227h5.626V15H53.805v6.434Z",
    transform: "translate(104.788 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,13.208c1.969,0,2.948,1.384,2.948,4.158s-.978,4.161-2.948,4.161H54.906c-1.96,0-2.948-1.387-2.948-4.161s.988-4.158,2.948-4.158Zm-.542,1.768H55.45c-1.065.006-1.6.647-1.6,1.923v.994c0,1.254.554,1.882,1.656,1.882h.1c1.1,0,1.65-.629,1.65-1.882V16.9c0-1.276-.529-1.917-1.6-1.923",
    transform: "translate(108.912 27.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.554,19.676v-2.22h1.858v3.972H57.656q-3.186,0-3.186-4.1t3.186-4.1h2.756v1.768H58.486q-2.122,0-2.124,1.923V17.8q0,1.881,2.04,1.879Z",
    transform: "translate(114.177 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.992,21.429H58.224q-1.551,0-1.551-1.669V14.71c0-.991.517-1.483,1.551-1.483h3.768v1.762H58.571v1.474h2.842v1.743H58.571v1.455h3.421Z",
    transform: "translate(118.795 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.578,21.435V15h-1.9V13.227H64.3V15H62.489v6.434Z",
    transform: "translate(122.99 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.632,18.268v3.192H60.774V13.225h1.858V16.5h2.285V13.225h1.858v8.236H64.917V18.268Z",
    transform: "translate(127.392 27.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.316,21.429H64.548Q63,21.429,63,19.76V14.71c0-.991.517-1.483,1.551-1.483h3.768v1.762H64.895v1.474h2.842v1.743H64.895v1.455h3.421Z",
    transform: "translate(132.051 27.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.843,14.928v6.505H65L65,13.225h4.3a2.017,2.017,0,0,1,1.489.533,1.96,1.96,0,0,1,.57,1.517,2.189,2.189,0,0,1-.663,1.564l-.721.851a.548.548,0,0,0-.053.573l1.771,3.17H69.438l-1.365-2.672a1.387,1.387,0,0,1,0-1.582l1.35-1.616a.644.644,0,0,0,.167-.418c0-.146-.093-.217-.276-.217Z",
    transform: "translate(136.246 27.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.552,16.456A16.455,16.455,0,1,1,19.1,0,16.456,16.456,0,0,1,35.552,16.456",
    transform: "translate(5.54 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.653,40.124A17.035,17.035,0,1,1,35.688,23.089,17.051,17.051,0,0,1,18.653,40.124m0-32.522A15.487,15.487,0,1,0,34.14,23.089,15.5,15.5,0,0,0,18.653,7.6",
    transform: "translate(3.398 12.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.923,39.175A17.035,17.035,0,1,1,39.958,22.14,17.053,17.053,0,0,1,22.923,39.175m0-32.522A15.487,15.487,0,1,0,38.41,22.14,15.5,15.5,0,0,0,22.923,6.653",
    transform: "translate(12.348 10.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.735,18.856a7.867,7.867,0,1,1-7.867-7.867,7.869,7.869,0,0,1,7.867,7.867",
    transform: "translate(0 23.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.787,18.934a4.41,4.41,0,1,1-4.412-4.412,4.412,4.412,0,0,1,4.412,4.412",
    transform: "translate(18.794 30.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.227,13.877a4.41,4.41,0,1,1-4.412-4.412,4.412,4.412,0,0,1,4.412,4.412",
    transform: "translate(32.294 19.839)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c9cec17a18163de593f76b2cf6df7420.svg";
export { ForwardRef as ReactComponent };